@import "../../../constants.scss";

.add-automation-card {
  background-color: var(--add-automation-card-background);
  width: 350px;
  height: 100%;
  border-radius: var(--border-radius-s-m);
  box-shadow: var(--shadow-low);
  border: var(--border-style);
  padding: var(--spacing-5);
  display: flex;
  flex-direction: column;

  .card-header {
    display: flex;
    flex-direction: row;
    color: var(--add-automation-card-header-color);
    align-items: center;
    justify-items: center;
    margin-bottom: var(--spacing-1);
    flex-shrink: 0;

    i {
      font-size: 16px;
      margin-right: var(--spacing-2);
      line-height: var(--h3-line-height);
    }

    h3 {
      color: inherit;
      margin: 0;
    }
  }

  .card-description {
    @include b2-typography;
    flex: 1;
  }

  .card-integrations {
    margin-top: var(--spacing-2);
    height: 20px;
    width: fit-content;
    margin-bottom: var(--spacing-5);
    flex-shrink: 0;
  }

  .card-labels {
    display: flex;
    flex-direction: row;
    gap: var(--spacing-1);
    flex-shrink: 0;
  }

  &:not(.is-empty):not(.is-disabled):hover {
    background-color: var(--add-automation-card-background-hover);
    box-shadow: var(--shadow-medium);
    cursor: pointer;
  }

  &.is-disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  &.is-empty {
    border: 1px solid var(--add-automation-card-border-empty);
    background-color: var(--add-automation-card-background-empty);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    img {
      height: 50px;
    }
  }
}
